/**
 * Filename: simpleLineChart.js
 * Simple line chanrt to show simple chart
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Brush} from 'recharts';
import * as dataService from "../service/data-info-chart/requestsUtil";
import {ANNUAL_INCOME, WHITOUT_INFORMATION, GRAPH_MARGIN} from "../utils/constants";
import * as cbu from "../utils/checkBusinessUnit";
import * as formatter from "../utils/formatters";

var Loader = require('react-loader');

class AnnualIncome extends Component {

  constructor(props) {
    super(props);
    this.state = {datas: [], loaded: false};
  }

  componentDidMount() {
    dataService.getFetch(ANNUAL_INCOME + cbu.checkBusinessUnit(this.props.bu))
      .then((data) => {
        this.setState({datas: data, loaded: true});
      });
  }

  render() {

    if (this.state.datas.length > 0) {
      return (
        <Loader top={"90%"} loaded={this.state.loaded}>
          <ResponsiveContainer>
            <LineChart width={600} height={300} data={this.state.datas}
                       margin={GRAPH_MARGIN}>
              <XAxis dataKey="month"/>
              <YAxis tickFormatter={formatter.formatNumber} scale={'linear'}/>
              <CartesianGrid/>
              <Tooltip formatter={formatter.formatNumberMoney}/>
              <Line type="linear" name={"Meta"} dataKey="goal" stroke="#01ad32" strokeDasharray="5 5"/>
              <Line type="linear" name={"Monto"} dataKey="amount" stroke="#222"/>
              <Line type="linear" name={"Anterior"} dataKey="previous" stroke="#777" strokeDasharray="5 5"/>
              <Legend verticalAlign={"top"}/>
              <Brush dataKey={"mes"} height={20}/>
            </LineChart>
          </ResponsiveContainer>
        </Loader>
      );
    } else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }


  }
}

// Connect linechartdata as props to compenent
function mapStateToProps(state) {
  return {
    lineChartData: state.monthlyRecovery
  }
}

export default connect(mapStateToProps)(AnnualIncome);



// WEBPACK FOOTER //
// ./src/charts/annualIncome.js